import { render, staticRenderFns } from "./points_task_activity.vue?vue&type=template&id=5a0fa2c9&scoped=true"
import script from "./points_task_activity.vue?vue&type=script&lang=js"
export * from "./points_task_activity.vue?vue&type=script&lang=js"
import style0 from "./points_task_activity.vue?vue&type=style&index=0&id=5a0fa2c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0fa2c9",
  null
  
)

export default component.exports